import { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import { CompanyDetailsByCode } from "../services/ReduxTookit/Slice/ProjectTermRedux";
import Loader, { LoaderType } from "../component/common-component/Loader";
import Nodata from "../component/common-component/Nodata";
import {
  GetDeveleoperVsClientContract,
  GetQDLVsDeveloperContract,
} from "../services/ReduxTookit/Slice/DigiSignRedux";
import { toast } from "react-toastify";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";
import PrivacyPolicyViewModal from "../component/PrivacyPolicyViewModal";

const TermsandConditionModal = (props) => {
  let dispatch = useDispatch();
  const [ConditionData, setConditionData] = useState([]);
  const [ConditionLoader, setConditionLoader] = useState(false);
  const [ShowPrivacyModel, setShowPrivacyModel] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    acceptTerms: false,
    acceptPrivacy: false,
    agreeQuantum: false,
    agreeDeveloperClient: false,
  });
  const [viewLoading, setViewLoading] = useState({
    quantum: false,
    developerClient: false,
  });

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxes((prev) => ({ ...prev, [name]: checked }));
  };
  const allChecked =
    checkboxes.acceptTerms &&
    checkboxes.acceptPrivacy &&
    checkboxes.agreeQuantum &&
    checkboxes.agreeDeveloperClient;

  const getConditionData = async () => {
    setConditionLoader(true);
    dispatch(CompanyDetailsByCode())
      .then((response) => {
        if (response?.payload?.isValidate) {
          setConditionData(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setConditionData([]);
        }
      })
      .finally(() => {
        setConditionLoader(false);
      });
  };

  const handleViewClick = async (type) => {
    if (type === "acceptPrivacy") {
      setShowPrivacyModel(true);
      return;
    }
    setViewLoading((prev) => ({ ...prev, [type]: true }));
    try {
      let res;
      if (type === "quantum") {
        let body = "view";
        res = await dispatch(GetQDLVsDeveloperContract(body));
      } else if (type === "developerClient") {
        res = await dispatch(GetDeveleoperVsClientContract());
      }

      if (res?.payload?.isValidate) {
        const fileURL = res?.payload?.data?.data;
        window.open(fileURL, "_blank");
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setViewLoading((prev) => ({ ...prev, [type]: false }));
    }
  };

  const CheckboxWithLoader = ({ id, name, label, viewType }) => (
    <div className="form-check checkbox-height">
      {ConditionLoader ? (
        <Loader type={LoaderType.FileContent} count={1} />
      ) : (
        <>
          <input
            type="checkbox"
            className="form-check-input"
            id={id}
            name={name}
            checked={checkboxes[name]}
            onChange={handleCheckboxChange}
          />
          <label
            className="form-check-label termsconditionModal term-checkbox d-flex align-items-center gap-1"
            htmlFor={id}
          >
            {label + " "}
            {viewType && (
              <>
                <button
                  type="button"
                  className="btn btn-link p-0 cursor-pointer term-checkbox"
                  onClick={() => handleViewClick(viewType)}
                  disabled={viewLoading[viewType]}
                >
                  {viewLoading[viewType] ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "View"
                  )}
                </button>
              </>
            )}
          </label>
        </>
      )}
    </div>
  );

  useEffect(() => {
    getConditionData();
  }, []);

  const closePrivacyModel = () => {
    setShowPrivacyModel(false);
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
        // className="termsandcondition"
        backdrop="static"
        className="terms-height"
      >
        {props?.loader && <MainpageLoader />}
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Terms and Condition
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-0">
          {ConditionLoader ? (
            <Loader type={LoaderType.FileContent} count={25} />
          ) : (
            <>
              {/* Confirmed from Ashish */}
              {ConditionData?.qdldevtermandconditions?.length > 0 ? (
                <>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: ConditionData?.qdldevtermandconditions,
                    }}
                  />
                  <CheckboxWithLoader
                    id="acceptTerms"
                    name="acceptTerms"
                    label="Accept Terms & Conditions"
                    viewType=""
                  />
                  <CheckboxWithLoader
                    id="acceptPrivacy"
                    name="acceptPrivacy"
                    label="Accept Privacy & Policy"
                    viewType="acceptPrivacy"
                  />
                  <CheckboxWithLoader
                    id="agreeQuantum"
                    name="agreeQuantum"
                    label="Agree to Quantum Datalytica LLC & Developer Contract"
                    viewType="quantum"
                  />
                  <CheckboxWithLoader
                    id="agreeDeveloperClient"
                    name="agreeDeveloperClient"
                    label="Agree to Developer & Client Contract"
                    viewType="developerClient"
                  />
                </>
              ) : (
                <Nodata />
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="p-1">
          <div className="text-end">
            {/* <button
              className="grey-btn w-auto me-3"
              type="reset"
              onClick={props.onHide}
            >
              Reject
            </button> */}
            <button
              disabled={!allChecked || props.loader}
              // className="blue-btn w-auto disable-blue-btn"
              className={`${
                !allChecked || props.loader
                  ? "disable-blue-btn w-auto"
                  : "blue-btn w-auto "
              } btn-sm`}
              onClick={() => {
                props.onsubmit();
                props.onHide();
              }}
            >
              {props?.loader ? <SubmitLoading /> : "Accept"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {ShowPrivacyModel && (
        <PrivacyPolicyViewModal
          privacyPolicy={ConditionData?.qdldevprivacypolicy}
          showModal={ShowPrivacyModel}
          closeModel={closePrivacyModel}
        />
      )}
    </>
  );
};

export default TermsandConditionModal;
